import type { ReactNode } from 'react';

export const symbol_horizontal_distribute: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M109.82-80Q97-80 88.5-88.63 80-97.25 80-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM444.5-294.58Q430-309.17 430-330v-300q0-20.83 14.62-35.42Q459.24-680 480.12-680q20.88 0 35.38 14.58Q530-650.83 530-630v300q0 20.83-14.62 35.42Q500.76-280 479.88-280q-20.88 0-35.38-14.58Zm384 205.95Q820-97.25 820-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
